import React from 'react'
import dialog from 'services/dialog'

// Components
import GlobeLogo from 'assets/images/white-logo.png'
import PayTrackLogo from 'assets/images/paytrack-logo.png'
import IconCheck from 'ui/Icons/IconCheck'
import IconQuestion from 'ui/Icons/IconQuestion'

// Styles
import './LoginBanner.scss'

const LoginBanner = () => {
  const onHSClick = () => {
    dialog.alert({
      message: (
        <div>
          <a
            id="download-faq"
            href="https://drive.google.com/file/u/2/d/1am3vF3fvI2E7fNf6hwZI_8QTeiBYinRU/view?usp=sharing"
            className="link"
          >
            Download FAQ
          </a>
          <br />
          <a
            id="link-to-youtube"
            href="https://www.youtube.com/"
            className="link"
          >
            Link to Youtube
          </a>
        </div>
      ),
      icon: <IconQuestion />,
      onConfirm: ({ setVisible }) => {
        setVisible(false)
      },
    })
  }
  return (
    <>
      <div className="banner-component">
        <div className="banner-component__bottom"></div>
        <div className="banner-component__top">
          <div className="banner-content">
            <div className="banner-content__top">
              <img src={GlobeLogo} alt="globe Logo" className="logo1" />

              <img src={PayTrackLogo} alt="Paytrack logo" className="logo2" />

              <div className="body">
                <div className="body__text">
                  <p>A platform for Globe lessors. Here, you can:</p>
                </div>
                <ul className="body__features">
                  <li className="body__feature">
                    <IconCheck></IconCheck>
                    <span className="label">
                      View payment details from Globe
                    </span>
                  </li>

                  <li className="body__feature">
                    <IconCheck></IconCheck>
                    <span className="label">
                      Upload official receipt <i>(if applicable)</i>
                    </span>
                  </li>

                  <li className="body__feature">
                    <IconCheck></IconCheck>
                    <span className="label">View your contract/s details</span>
                  </li>

                  <li className="body__feature">
                    <IconCheck></IconCheck>
                    <span className="label">Manage your account</span>
                  </li>

                  <li className="body__feature">
                    <IconCheck></IconCheck>
                    <span className="label">Raise your concerns</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="banner-content__footer">
              <a
                id="stop-spam"
                href="https://www.globe.com.ph/stop-spam.html"
                className="--item"
              >
                #StopSPAM
              </a>

              <span id="help-support" className="--item" onClick={onHSClick}>
                Help & Support
              </span>

              <a
                id="contact-us"
                href="mailto:paytract@globe.com.ph"
                className="--item"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
        <div className="banner-component__line"></div>
      </div>
    </>
  )
}

export default LoginBanner
